import axios from 'axios'

export interface Options {
  schedule: number
  webinar: number
  timing: number
}

const options: Options = {
  schedule: 0,
  webinar: 0,
  timing: 0,
}

export function setOption(name: 'schedule' | 'webinar' | 'timing', value: number): void {
  options[name] = value
}

type resolver = (data: unknown) => void
type rejector = (err: Error) => void

interface QueueItem {
  name: string
  data?: unknown
  resolve: resolver
  reject: rejector
}

const queue: QueueItem[] = []

// eslint-disable-next-line @typescript-eslint/no-empty-function
const f = () => {
}

export function request<T>(name: string, data?: unknown): Promise<T> {
  const item: QueueItem = {
    name,
    data,
    resolve: f,
    reject: f,
  }
  const promise = new Promise<T>((res, rej) => {
    item.resolve = res as resolver
    item.reject = rej
  })
  queue.push(item)
  return promise
}

export function doQueue(): Promise<void> {
  if (!queue.length) {
    return Promise.resolve()
  }
  const q = [...queue]
  queue.length = 0
  const query: Record<string, unknown> = {}
  q.forEach((item) => {
    query[item.name] = typeof item.data === 'undefined' ? null : item.data
  })
  return axios
    .get<Record<string, unknown>>('/combined', {
      params: {
        ...options,
        query: JSON.stringify(query),
      },
    })
    .then(({ data }) => q.forEach((item) => item.resolve(data[item.name])))
    .catch((err) => q.forEach((item) => item.reject(err)))
}
